// @ts-nocheck
import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Stack, Group, Center } from '@/components/ui/layout';
import { Title, Text, Button, Anchor } from '@/components/ui/core';
import { TextInput, PasswordInput, Checkbox } from '@/components/ui/inputs';
import { IconMail, IconLock, IconArrowLeft, IconShieldCheck, IconRocket, IconUsers } from '@tabler/icons-react';
import { AuthLayoutWrapper } from '../components';
import { SocialLoginButtons } from '../components';

export default function LoginSplit() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [rememberMe, setRememberMe] = useState(false);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    console.log('Login attempt:', { email, password, rememberMe });
  };

  const splitContent = (
    <Stack gap="xl" p="xl" style={{ color: 'white' }}>
      <div>
        <Title order={1} c="white" mb="md">Welcome to Our Platform</Title>
        <Text size="lg" style={{ opacity: 0.9 }}>
          Join thousands of users who trust us for their daily operations.
        </Text>
      </div>

      <Stack gap="lg" mt="xl">
        <Group gap="md">
          <Center
            style={{
              width: 48,
              height: 48,
              borderRadius: 12,
              backgroundColor: 'rgba(255,255,255,0.15)',
            }}
          >
            <IconShieldCheck size={24} />
          </Center>
          <div>
            <Text fw={600}>Secure & Reliable</Text>
            <Text size="sm" style={{ opacity: 0.8 }}>Enterprise-grade security</Text>
          </div>
        </Group>

        <Group gap="md">
          <Center
            style={{
              width: 48,
              height: 48,
              borderRadius: 12,
              backgroundColor: 'rgba(255,255,255,0.15)',
            }}
          >
            <IconRocket size={24} />
          </Center>
          <div>
            <Text fw={600}>Lightning Fast</Text>
            <Text size="sm" style={{ opacity: 0.8 }}>Optimized performance</Text>
          </div>
        </Group>

        <Group gap="md">
          <Center
            style={{
              width: 48,
              height: 48,
              borderRadius: 12,
              backgroundColor: 'rgba(255,255,255,0.15)',
            }}
          >
            <IconUsers size={24} />
          </Center>
          <div>
            <Text fw={600}>10K+ Users</Text>
            <Text size="sm" style={{ opacity: 0.8 }}>Trusted worldwide</Text>
          </div>
        </Group>
      </Stack>
    </Stack>
  );

  return (
    <AuthLayoutWrapper
      variant="split"
      splitContent={splitContent}
      backgroundImage="https://images.unsplash.com/photo-1557683316-973673baf926?w=1200&auto=format&fit=crop"
    >
      <Stack gap="lg">
        {/* Back button */}
        <Button
          component={Link}
          to="/app/demo/auth-pages/login"
          variant="subtle"
          size="xs"
          leftSection={<IconArrowLeft size={14} />}
          w="fit-content"
        >
          Back to variants
        </Button>

        {/* Header */}
        <div>
          <Title order={2}>Sign in</Title>
          <Text c="dimmed" size="sm" mt="xs">
            Welcome back! Please enter your details.
          </Text>
        </div>

        {/* Form */}
        <form onSubmit={handleSubmit}>
          <Stack gap="md">
            <TextInput
              label="Email"
              placeholder="your@email.com"
              leftSection={<IconMail size={16} />}
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />

            <PasswordInput
              label="Password"
              placeholder="Your password"
              leftSection={<IconLock size={16} />}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />

            <Group justify="space-between">
              <Checkbox
                label="Remember me"
                checked={rememberMe}
                onChange={(e) => setRememberMe(e.currentTarget.checked)}
              />
              <Anchor component={Link} to="/app/demo/auth-pages/forgot-password/split" size="sm">
                Forgot password?
              </Anchor>
            </Group>

            <Button type="submit" fullWidth>
              Sign in
            </Button>
          </Stack>
        </form>

        {/* Social Login */}
        <SocialLoginButtons
          providers={['google', 'apple', 'github']}
          layout="icons-only"
        />

        {/* Register Link */}
        <Text ta="center" size="sm">
          Don't have an account?{' '}
          <Anchor component={Link} to="/app/demo/auth-pages/register/split" fw={500}>
            Sign up for free
          </Anchor>
        </Text>
      </Stack>
    </AuthLayoutWrapper>
  );
}
